const DEFAULT_MESSAGE =
  "No pudimos completar la solicitud. Inténtelo nuevamente.";

export function getApiErrorMessage(error, fallback = DEFAULT_MESSAGE) {
  if (!error?.response) {
    return navigator.onLine
      ? "No pudimos conectar con el servidor. Inténtelo nuevamente en unos segundos."
      : "Parece que no tiene conexión a Internet. Revise su conexión e inténtelo nuevamente.";
  }

  const status = error.response.status;
  const serverMessage =
    error.response.data?.message ||
    error.response.data?.error_description ||
    error.response.data?.error;

  if (status === 401 || status === 404) {
    return "El correo o la contraseña no son correctos.";
  }

  if (status === 403) {
    return (
      serverMessage ||
      "Su cuenta todavía no está habilitada. Revise el correo de confirmación."
    );
  }

  if (status === 422) {
    return (
      serverMessage || "Revise los datos introducidos e inténtelo nuevamente."
    );
  }

  if (status >= 500) {
    return "El servicio presenta una dificultad temporal. Sus datos no se han perdido; inténtelo nuevamente.";
  }

  return serverMessage || error.message || fallback;
}
